import { SidebarTrigger } from "@components/ui/sidebar";
import { useAppSelector } from "@redux/hooks";
import { selectStudentSummaryRetrieval } from "@academy-context/read/application/use-cases/student/summary-retrieval/selectors/student-summary-selectors";
import { Skeleton } from "@shared-kernel/primary/shared/shadcn/ui/skeleton";
import { StudentBalanceTopbar } from "./student-balance-topbar.content";

const StudentBalanceTopbarSkeleton = () => {
  return (
    <div className="sticky top-0 z-10 flex items-center border-b bg-background/80 p-2 backdrop-blur-sm">
      <SidebarTrigger />
      <div className="mx-auto flex items-center justify-center gap-2">
        <Skeleton className="h-4 w-10" />
        <Skeleton className="h-6 w-24" />
      </div>
    </div>
  );
};

export const StudentBalanceTopbarContainer = () => {
  const { data, fetching } = useAppSelector(selectStudentSummaryRetrieval);

  if (fetching === "pending" || fetching === "idle") {
    return <StudentBalanceTopbarSkeleton />;
  }

  return (
    <div className="sticky top-0 z-10 flex items-center border-b bg-background/80 p-2 py-3  backdrop-blur-sm">
      <SidebarTrigger />
      <StudentBalanceTopbar balance={data.balance} />
    </div>
  );
};
